module.exports = __webpack_public_path__ + "img/vk.e91a695d.png";